import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { appQueryClient } from "app/AppQueryClient";
import { useReadLocalStorage } from "usehooks-ts";

export const AppQueryClientProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const showDevTools = useReadLocalStorage("show-dev-tools");
  return (
    <QueryClientProvider client={appQueryClient}>
      {children}
      {showDevTools ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
};
